import '@fontsource-variable/fraunces/full.css';
import '@fontsource-variable/inter/wght.css';
import './app/styles/tokens.css';
import './app/styles/base.css';
import './app/styles/ui.css';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './app/App';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
